import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

export const FormAdditionText = styled.div`
  border-bottom: 1px solid ${color.SILVER};
  border-top: ${p => (p.noTopBorder ? 0 : `1px solid ${color.SILVER}`)};
  padding: ${p => (p.thin ? '0.625rem' : '1.25rem')} 0;
  color: ${color.AQUAMARINE};
  cursor: pointer;
  &:hover {
    background: ${color.AQUA_OVERLAY};
    color: ${color.SCOOTER};
  }
`
